import React from 'react';
import { Card } from 'react-bootstrap';
import classNames from 'classnames';
import IconButton from 'components/common/IconButton';

/**
 * Pie de página del wizard que muestra el botón de envío en los pasos válidos.
 */
const LayoutFooter = ({ step, blocking, handleSubmitAnswer }) => (
	<Card.Footer
		className={classNames('px-md-6 bg-light', {
			'd-none': [1, 3, 5, 7, 9, 11].includes(step),
			'd-flex': [2, 4, 6, 8, 10].includes(step)
		})} >
		{[2, 4, 6, 8, 10].includes(step) && (
			<IconButton
				variant="primary"
				className="ms-auto px-5"
				type="button"
				onClick={handleSubmitAnswer}
				icon={'chevron-right'}
				iconAlign="right"
				transform="down-1 shrink-4"
				disabled={blocking} >
				Submit
			</IconButton>
		)}
	</Card.Footer>
);

export default LayoutFooter;